import { SessionGuard } from "./SessionGuard";

/** Instructor pages. The rules live in SessionGuard. */
export const InstructorRouter = ({ children }) => (
  <SessionGuard area="instructor">{children}</SessionGuard>
);
